export default __webpack_public_path__ + "static/media/1906.de5d66c5.png";